import { Component } from '@angular/core';
import { ScheduleFormComponent } from '../../../../../components/forms/campaignforms/schedule-form/schedule-form.component';
import { SchedulePreviewComponent } from '../../../../../components/forms/campaignpreviews/schedule-preview/schedule-preview.component';
import { EditScheduleFormComponent } from '../../../../../components/forms/campaignforms/edit-schedule-form/edit-schedule-form.component';

/** Wizard step 4: campaign dates and per-message send times. */
@Component({
  selector: 'app-schedule',
  standalone: true,
  imports: [ScheduleFormComponent, SchedulePreviewComponent, EditScheduleFormComponent],
  templateUrl: './schedule.component.html',
  styleUrl: '../wizard-step.css',
})
export class ScheduleComponent {
  openEditPopup = false;

  openPopup(message: object) {
    this.openEditPopup = true;
  }

  closePopup(event: boolean) {
    this.openEditPopup = event;
  }
}
